// extracted by mini-css-extract-plugin
export var progressContainer = "_gg-0";